import { displayToast } from '../../components/Toaster/displayToast';
import generateHeaders from '../myHeaders';

const createUserColorSwatch = (
    id: number | undefined,
    label: string,
    rank: number,
    colorSwatch: string[],
    successMessage: string,
    errorMessage: string,
    mutate: () => void,
    selectedSchema: string,
) => {
    const url = `${process.env.REACT_APP_API_URL}/user/color-swatches`;

    const body = {
        id,
        label,
        rank,
        colorSwatch,
    };

    const requestOptions = {
        method: 'POST',
        headers: generateHeaders(selectedSchema),
        body: JSON.stringify(body),
    };

    return fetch(url, requestOptions)
        .then((response) => {
            if (!response.ok) {
                displayToast(errorMessage, 'error');

                return undefined;
            }
            displayToast(successMessage, 'success');
            mutate();

            return response.json();
        }).catch(() => {
            displayToast(errorMessage, 'error');
        });
};

export default createUserColorSwatch;
